import { DateRangePickerShape } from 'react-dates'
import { isInclusivelyAfterDay } from 'react-dates'

import {
  renderCustomArrowIcon,
  renderCustomCloseIcon,
  renderCustomInputIcon,
  renderNavNextButton,
  renderNavPrevButton,
} from 'common/components/datePicker/datePickerIcons'
import type {
  CustomProps,
  DateRangePickerType,
  DefaultOption,
  FocusedInputType,
  SelectorDate,
  TooltipProps,
} from 'common/components/dateRange/interfaces'

import DateRange from './DateRange'
import { options } from './defaultOptions'

import datePickerStyles from 'common/components/datePicker/DateStyles.module.css'

const DateRangePerFlag = (
  dateRangeProps: DateRangePickerShape & CustomProps
) => {
  return (
    <div className={datePickerStyles.container}>
      <DateRange
        renderNavNextButton={renderNavNextButton}
        renderNavPrevButton={renderNavPrevButton}
        customInputIcon={renderCustomInputIcon(dateRangeProps.disabled)}
        customCloseIcon={renderCustomCloseIcon()}
        customArrowIcon={renderCustomArrowIcon()}
        {...dateRangeProps}
      />
    </div>
  )
}

export default DateRangePerFlag

export { isInclusivelyAfterDay, options }

export type {
  CustomProps,
  DefaultOption,
  SelectorDate,
  DateRangePickerType,
  FocusedInputType,
  TooltipProps,
}
